import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", null, "Add-Ons", -1 /* HOISTED */)
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "card h-100" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "card-title text-uppercase" }
const _hoisted_6 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_7 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_8 = { class: "mt-3" }
const _hoisted_9 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.items, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col-12 col-md mb-3 mb-md-0",
          key: item.addon_type
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h6", _hoisted_5, _toDisplayString(item.addon_type), 1 /* TEXT */),
              _createElementVNode("div", null, [
                _createElementVNode("span", null, _toDisplayString($options.currency_symbol), 1 /* TEXT */),
                _createElementVNode("span", null, _toDisplayString($options.get_price(item)), 1 /* TEXT */),
                _createElementVNode("span", null, "/ " + _toDisplayString(item.unit), 1 /* TEXT */),
                ($props.site.subscription_type === 'Yearly')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "/ year"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_7, "/ month"))
              ]),
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.actions, (action) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: action.label
                  }, [
                    _createElementVNode("a", {
                      href: "",
                      class: "text-dark",
                      onClick: _withModifiers(action.handler, ["prevent"])
                    }, _toDisplayString(action.label), 9 /* TEXT, PROPS */, _hoisted_9)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}